import { RequestQueue, createQueue } from './request-queue';

import { HttpClient } from '@angular/common/http';
import { ICard } from '@vantage-platform/store/lib/models';
import { Injectable } from '@angular/core';
import { AppState, getCurrentApp, instance, user } from '@vantage-platform/store';
import { Store } from '@ngrx/store';
import { Observable, forkJoin } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { environment } from 'apps/vantage-focus/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CardDataService {
  private requestsQueue: RequestQueue<ICard>;

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.initRequestQueue();
  }

  private initRequestQueue() {
    this.requestsQueue = createQueue<ICard>(7);
  }

  getCard(cardId: number, focusBoardId: number, isCollection = false): Observable<ICard> {
    return this.resolveLanguageId().pipe(
      switchMap((languageId) => {
        const endpoint = isCollection ? 'collections' : 'boards';
        const url = `me/${endpoint}/${focusBoardId}/cards/${cardId}?embed=all&language-id=${languageId}`;

        return this.requestsQueue.queue(
          this.http.get(`${environment.api.url}${url}`) as Observable<ICard>
        );
      })
    );
  }

  getCardByGeoLocation(
    cardId: number,
    focusBoardId: number,
    geoLocation: string,
    isCollection = false
  ): Observable<ICard> {
    return this.resolveLanguageId().pipe(
      switchMap((languageId) => {
        const endpoint = isCollection ? 'collections' : 'boards';
        const url = `me/${endpoint}/${focusBoardId}/cards/${cardId}?embed=all&dynamic-location-name=${geoLocation}&language-id=${languageId}`;

        return this.http.get(`${environment.api.url}${url}`) as Observable<ICard>;
      })
    );
  }

  pinCard(cardId: number, collectionId: number) {
    console.log(cardId, collectionId);
    const url = `me/boards/collections/${collectionId}/cards/${cardId}`;
    const body = {
      focusBoardID: collectionId,
      focusBoardCardID: cardId,
    };

    return this.http.post(`${environment.api.url}${url}`, body);
  }

  unPinCard(cardId: number, collectionId: number) {
    console.log(cardId, collectionId);
    const url = `me/boards/collections/${collectionId}/cards/${cardId}`;

    return this.http.delete(`${environment.api.url}${url}`, {
      observe: 'response',
    });
  }

  private resolveLanguageId(): Observable<number> {
    return forkJoin({
      app: this.store.select(getCurrentApp).pipe(take(1)),
      currentInstance: this.store.select(instance).pipe(take(1)),
      currentUser: this.store.select(user).pipe(take(1)),
    }).pipe(
      map(({ app, currentInstance, currentUser }) => {
        return (
          currentUser?.defaultLanguageID ??
          app?.languageID ??
          app?.instanceRef?.languageID ??
          1
        );
      })
    );
  }
}
